var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{attrs:{"styleName":"opt_header"}},[_vm._v("\n  "+_vm._s(_vm.roomDetail.data.lessonName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }